/**
 * @generated SignedSource<<702d4f2310ddb67d81b1cf8901e5780c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useTrackedAuctionType_item$data = {
  readonly getCategoriesByLevel: ReadonlyArray<{
    readonly name: string | null;
  } | null> | null;
  readonly vertical: VerticalType | null;
  readonly " $fragmentType": "useTrackedAuctionType_item";
};
export type useTrackedAuctionType_item$key = {
  readonly " $data"?: useTrackedAuctionType_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useTrackedAuctionType_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useTrackedAuctionType_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vertical",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "level",
          "value": 1
        }
      ],
      "concreteType": "Category",
      "kind": "LinkedField",
      "name": "getCategoriesByLevel",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": "getCategoriesByLevel(level:1)"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "276bfd53b7e35bb9e0ffc0835dc6e658";

export default node;
